import createHistory from 'history/createBrowserHistory';

const getHistory = () => createHistory();

export default getHistory;

